"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var toast_1 = require("../components/toast");
var localization_1 = require("../components/localization");
var HTML_TAG_REG_EXPS = Object.freeze({
    iframe: /<(?:iframe) (.* )?(?:src=")(.*)".*>.*<\/iframe>/,
    img: /<(?:img) (.* )?(?:src=")(.*)".*\/>/,
    a: /<(?:a) (.* )?(?:href=")(.*)".*>.*<\/a>/
});
var ERROR_LOCALIZATION_KEYS = Object.freeze({
    httpIsNotAllowed: 'httpIsNotAllowed',
    urlIsMalformed: 'urlIsMalformed'
});
var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    UrlHelper.isHttps = function (url) {
        return /^(?:https:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&\'\(\)\*\+,;=.%]+$/gm.test(url);
    };
    UrlHelper.isHttp = function (url) {
        return /^(?:http:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&\'\(\)\*\+,;=.%]+$/gm.test(url);
    };
    UrlHelper.isUrl = function (url) {
        return /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&\'\(\)\*\+,;=.%]+$/gm.test(url);
    };
    UrlHelper.getUrlFromHtml = function (html) {
        var url = new RegExp("(?:src|href)=[\"|'](\\S+)[\"|']", 'i').exec(html);
        return url ? url[1] : null;
    };
    UrlHelper.showError = function (errorCode) {
        if (errorCode === void 0) { errorCode = UrlHelper.errorLocalizationKeys.httpIsNotAllowed; }
        toast_1.toast.error((0, localization_1.localize)(errorCode));
    };
    UrlHelper.isHtml = function (data, rootTag) {
        return rootTag
            ? this.htmlTagRegExp[rootTag.toLowerCase()]
            : /<(?:iframe|img|a) .*(?:src|href=")([^script].*)".*(>.*<)?(\/)?(:?iframe|a)?>/.test(data);
    };
    UrlHelper.validate = function (urlOrHtml, rootTag) {
        if (rootTag === void 0) { rootTag = null; }
        return __awaiter(this, void 0, void 0, function () {
            var url, http, message;
            return __generator(this, function (_a) {
                try {
                    url = this.isHtml(urlOrHtml, rootTag) ? this.getUrlFromHtml(urlOrHtml) : urlOrHtml;
                    if (url === null) {
                        throw new Error(UrlHelper.errorLocalizationKeys.urlIsMalformed);
                    }
                    url = (url.indexOf('://') === -1) ? 'https://' + url : url;
                    if (this.isHttp(url)) {
                        throw new Error(UrlHelper.errorLocalizationKeys.httpIsNotAllowed);
                    }
                    if (this.isHttps(url)) {
                        return [2 /*return*/, true];
                    }
                    if (this.isUrl(url)) {
                        http = new XMLHttpRequest();
                        http.open('HEAD', this.normalizeUrl(url));
                        http.onreadystatechange = function () {
                            if (this.readyState !== this.DONE) {
                                throw new Error(UrlHelper.errorLocalizationKeys.httpIsNotAllowed);
                            }
                        };
                        http.send();
                    }
                    throw new Error(UrlHelper.errorLocalizationKeys.urlIsMalformed);
                }
                catch (error) {
                    message = '';
                    if (typeof error === 'string') {
                        message = error;
                    }
                    else {
                        message = error.message;
                    }
                    this.showError(message);
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
            });
        });
    };
    UrlHelper.normalizeUrl = function (url) {
        return /^https/gm.test(url) ? url : "https://".concat(url);
    };
    UrlHelper.normalizeHtmlUrl = function (html) {
        var url = this.getUrlFromHtml(html), newUrl = this.normalizeUrl(url);
        if (url !== newUrl) {
            html = html.replace(url, newUrl);
        }
        return html;
    };
    UrlHelper.htmlTagRegExp = HTML_TAG_REG_EXPS;
    UrlHelper.errorLocalizationKeys = ERROR_LOCALIZATION_KEYS;
    return UrlHelper;
}());
exports.default = UrlHelper;
